import * as ReactDOM from "react-dom/client";
import { MantineProvider } from "@mantine/core";
import { Notifications } from "@mantine/notifications";
import { DEFAULT_THEME } from "styles/default-theme";
import App from "./App";
import "./styles/tailwind.css";
import "@fortawesome/fontawesome-free/css/all.min.css";
import { LoanTypeProvider } from "context/LoanTypeContext";

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);
root.render(
  <MantineProvider
    theme={DEFAULT_THEME}
    withCSSVariables
    withGlobalStyles
    withNormalizeCSS
  >
    <Notifications position="top-right" limit={5} />
    {/* LoanTypeContext */}
    <LoanTypeProvider>
      <App />
    </LoanTypeProvider>
  </MantineProvider>
);
